module.exports = __webpack_public_path__ + "category_car_check.png";